import "./LoginPage.css";
import { Link, useNavigate } from "react-router-dom";
import brand from "../assets/img/brand-nav.png";
import axios from "axios";
import { useDispatch } from "react-redux";
import actions from "../redux/actions/customerActions";
import { useForm } from "react-hook-form";
import AboutThisProject from "../components/AboutThisProject";
import { useState } from "react";
import { toast } from "react-toastify";

function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [apiStatus, setApiStatus] = useState(0);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data, e) => {
    e.preventDefault();
    try {
      const response = await toast.promise(
        axios({
          method: "POST",
          url: process.env.REACT_APP_API_URL + "/api/customers/tokens",
          data: data,
        }),
        {
          pending: "Validating credentials...",
          success: "Successfully logged",
          error: "Invalid credentials",
        }
      );
      dispatch(actions.createCustomer(response.data));
      navigate("/");
    } catch (error) {
      if (error.status === 401) {
        alert("Ups!, algo ha salido mal.");
      } else {
        setApiStatus(error.response.status);
      }
    }
  };

  return (
    <div className="login-page animate__animated animate__fadeIn">
      <AboutThisProject />
      <div className="container my-0 px-lg-5">
        <div className="row gx-4 gx-lg-5 justify-content-center align-items-center mb-5 h-100">
          <div className="form-card-login col-md-10 col-lg-8 col-xl-7 btn-light rounded shadow">
            <div className="contenido-card d-flex flex-column align-items-center">
              <div className="col-12 d-flex flex-column align-items-center">
                <Link to="/">
                  <img src={brand} className="img-fluid mb-4" alt="" />
                </Link>
              </div>
              {(apiStatus === 400 || apiStatus === 401) && (
                <p className="text-danger fw-bold">
                  Incorrect E-mail or Password
                </p>
              )}
              <form onSubmit={handleSubmit(onSubmit)} className="col-lg-8 py-3">
                <h1 className="fs-4">Login to your account</h1>
                <div className="my-3">
                  <label htmlFor="username" className="form-label ps-1">
                    E-mail
                  </label>
                  <input
                    autoComplete="off"
                    id="email"
                    type="text"
                    defaultValue="customer1@gmail.com"
                    className="form-control bg-light"
                    placeholder="Write your e-mail here..."
                    {...register("email", { required: true })}
                  />
                  {errors.email && (
                    <span className="f-roboto fs-7 text-danger">
                      This field is required
                    </span>
                  )}
                  <div className="my-3">
                    <label htmlFor="password" className="form-label ps-1">
                      Password
                    </label>
                    <input
                      autoComplete="off"
                      id="password"
                      type="password"
                      defaultValue="1234"
                      className="form-control bg-light"
                      placeholder="Write your password here..."
                      {...register("password", { required: true })}
                    />
                    {errors.password && (
                      <span className="f-roboto fs-7 text-danger">
                        This field is required
                      </span>
                    )}
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn px-4 btn-yellow text-uppercase rounded mt-3"
                >
                  Send
                </button>
              </form>
              <div>
                <p className="pt-3 mb-5 text-secondary">
                  If you dont't have an account, register
                  <strong className="ms-1">
                    <Link to="/register" className="text-decoration-none link">
                      here
                    </Link>
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
